import { render, staticRenderFns } from "./SaveLogPopup.vue?vue&type=template&id=0588c6b1&scoped=true&"
import script from "./SaveLogPopup.vue?vue&type=script&lang=js&"
export * from "./SaveLogPopup.vue?vue&type=script&lang=js&"
import style0 from "./SaveLogPopup.vue?vue&type=style&index=0&id=0588c6b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0588c6b1",
  null
  
)

export default component.exports